<template>


    <DebugModeComponent v-if="debugData != undefined" :debugData="debugData" :labelPreview="labelPreview" />
    <NavigationComponent :navigationData="sectionData" :mainSettings="mainSettings" id="container-navigation" class="container-navigation" />

    <template v-for="(section, index) in sectionData" :key="index">

      <TitleComponent :titleData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'title' && section.config != ''" isMultiblock="false" />
      <FreeTextComponent :freetextData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'freeTexts' && section.config != ''" isMultiblock="false" />
      <TextComponent :textData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'text' && section.config != ''" isMultiblock="false" />
      <FeedbackComponent :feedbackData="section" :index="index" v-else-if="section.type == 'contact' && section.config != ''" isMultiblock="false" />
      <FactsComponent :factsData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'data' && section.config != ''" isMultiblock="false" />
      <GalleryComponent :pictureData="section" :mainSettings="mainSettings" :pictureKey="index" :index="index" v-if="section.type == 'pictures' && section.config != '' && sectionData[index].config.pictures != ''" isMultiblock="false" />
      <LayoutComponent :layoutData="section" :mainSettings="mainSettings" :pictureKey="index" :index="index" v-if="section.type == 'layout'&& section.config != ''" isMultiblock="false" />
      <LocationComponent :locationData="section" :index="index" v-if="section.type == 'maps' && section.config != ''" isMultiblock="false" />
      <VirtualTourComponent :virtualTourData="section" :index="index" v-if="section.type == 'virtualTour' && section.config != ''" isMultiblock="false" />
      <EnergyDataComponent :energyData="section" :index="index" v-if="section.type == 'energyData' && section.config != ''" isMultiblock="false" />
      <FilesComponent :fileData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'files' && section.config != ''" isMultiblock="false" />
      <ContactPersonComponent :contactPersonData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'contactPerson' && section.config != ''" isMultiblock="false" />
      <UnitListComponent :unitListData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'unitList' && section.config != ''" isMultiblock="false" />
      <VideoComponent :videoData="section" :mainSettings="mainSettings" :index="index" v-if="section.type == 'video' && section.config != ''" isMultiblock="false" />
      <MultiBlockComponent :multiData="section" :index="index" :pictureKey="index" v-if="section.type == 'combo' && section.config != ''" />
		</template>

    <FooterComponent :footerData="mainSettings"></FooterComponent>
  
</template>

<script>
import DebugModeComponent from "../DebugModeComponent.vue";
import TitleComponent from "./TitleComponent.vue";
import NavigationComponent from "./NavigationComponent.vue";
import FreeTextComponent from "./FreeTextComponent.vue";
import FactsComponent from "./FactsComponent.vue";
import GalleryComponent from "./GalleryComponent.vue";
import LocationComponent from "./LocationComponent.vue";
import TextComponent from "./TextComponent.vue";
import FeedbackComponent from "../FeedbackComponent.vue"
import VirtualTourComponent from "./VirtualTourComponent.vue";
import LayoutComponent from "./LayoutComponent.vue";
import EnergyDataComponent from "./EnergyDataComponent.vue";
import FilesComponent from "./FilesComponent.vue";
import UnitListComponent from "./UnitListComponent.vue";
import ContactPersonComponent from "./ContactPersonComponent.vue";
import VideoComponent from "./VideoComponent.vue";
import FooterComponent from "./FooterComponent.vue";
import MultiBlockComponent from "./MultiBlockComponent.vue";


export default {
  components: {
    TitleComponent,
    NavigationComponent,
    DebugModeComponent,
    FreeTextComponent,
    TextComponent,
    FeedbackComponent,
    FactsComponent,
    GalleryComponent,
    LocationComponent,
    VirtualTourComponent,
    LayoutComponent,
    EnergyDataComponent,
    FilesComponent,
    UnitListComponent,
    ContactPersonComponent,
    VideoComponent,
    FooterComponent,
    MultiBlockComponent,
  },

  props: {
    mainSettings: {
      type: Object
    },
    sectionData: {
      type: Object,
    },
    index: {
      type: Number,
    },
    debugData: {
			type: Object
		},
    isMultiblock: {
			type: String
		},
		labelPreview: {
			type: Array
		}
  },

  data() {
    return {
      isLoaded: false
    }
  },

  methods: {
    loaded() {
      this.isLoaded = true;
    },

    trimId() {
      let sections = document.querySelectorAll('#app section[id^="container"]');
      sections.forEach(section => section.id = section.id.split(" ").join(""));
    }
  },

  mounted() {
    this.loaded();
    this.trimId();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/sectionComponent.scss";
</style>